// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pwt-info-panel-left-to-right-animation[data-v-288265e6]{left:-41%;animation:left-to-right-288265e6 .7s linear forwards}.pwt-info-panel-right-to-left-animation[data-v-288265e6]{left:0;animation:right-to-left-288265e6 1s linear forwards}@keyframes left-to-right-288265e6{0%{left:-41%}to{left:0}}@keyframes right-to-left-288265e6{0%{left:0}to{left:-100%}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
